import { Fragment } from "react";

import { useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { alpha, lighten } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import constants from "../../assets/constants";
import { helperGetIsoDate } from "../../utils/helpers";
import OmniAvatar from "./omniAvatar";

const SymptomTrackingToDoListItem = props => {
  const { daysInThePast = 0, index = 0, onClickHandler = null } = props;
  const theme = useTheme();

  const getPrimaryText = inthePast => {
    let newData = "";
    if (inthePast === 0) {
      newData += "Track Today's Symptoms";
    } else if (inthePast === 1) {
      newData += "Enter Yesterday's Symptoms";
    } else {
      let aDay = helperGetIsoDate(inthePast);
      let date = new Date(aDay);
      newData += `Record ${constants.weekDayNamesLong[date.getDay()]}'s Symptoms`;
    }
    return newData;
  };
  const getDay = inthePast => {
    let aDay = helperGetIsoDate(inthePast);
    let date = new Date(aDay);
    return constants.weekDayNames[date.getDay()];
  };

  return (
    <ListItem
      dense
      key={index}
      disableGutters={true}
      onClick={() => {
        onClickHandler(daysInThePast); //just does all
      }}
      sx={[
        {
          padding: theme.spacing(1),
          paddingTop: 0,
          paddingBottom: 0,
          marginBottom: theme.spacing(1),
          borderRadius: theme.spacing(1),
          boxShadow: theme.shadows[3],
          color: theme.palette.secondary.contrastText,
        },
        {
          backgroundColor: alpha(theme.palette.secondary.main, 0.75),
          "&:hover": {
            backgroundColor: alpha(theme.palette.secondary.main, 0.5),
            cursor: "pointer",
          },
        },
      ]}
    >
      <Tooltip title="Last Value" placement="top">
        <OmniAvatar
          sx={[
            {
              width: 42,
              height: 42,
              fontSize: "1.2rem",
              boxShadow: theme.shadows[3],
            },
            {
              color: theme.palette.secondary.contrastText,
              backgroundColor: lighten(theme.palette.secondary.main, 0.5),
              border: `2px solid ${theme.palette.secondary.contrastText}`,
            },
          ]}
        >
          {getDay(daysInThePast)}
        </OmniAvatar>
      </Tooltip>
      <ListItemText
        primary={
          <Typography
            component="span"
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: 0,
              color: theme.palette.secondary.contrastText,
              webkitUserSelect: "none",
              userSelect: "none",
            }}
          >
            {getPrimaryText(daysInThePast)}
          </Typography>
        }
        secondary={
          <Fragment>
            <Typography
              component="span"
              variant="subtitle2"
              color="textPrimary"
              sx={{
                display: "flex",
                flexDirection: "row",
                marginLeft: theme.spacing(1),
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                marginTop: "-6px",
                color: theme.palette.secondary.contrastText,
                webkitUserSelect: "none",
                userSelect: "none",
              }}
            >
              {"Click Here"}
            </Typography>
          </Fragment>
        }
      />
    </ListItem>
  );
};

export default SymptomTrackingToDoListItem;
